export const environment = {
  production: false,
  apiBaseUrl: 'https://dermai.amatis.dev/api/v1'
};
